import { apiSlice } from "../../api/ApiService";

export const patientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientLoginWorkflow: builder.query({
      query: ({ accessToken, patientFhirId }) => {
        return {
          url: `/api/v1/Patient/login-workflow`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            patientFhirId: `${patientFhirId}`,
          },
        };
      },
      providesTags: (result, error, arg) => [
        { type: "PatientLoginWorkflow", id: arg },
      ],
    }),
  }),
  overrideExisting: false, // Prevent overriding existing endpoints unless intended
});

export const { useGetPatientLoginWorkflowQuery } = patientApiSlice;
